<template>
    <Modal v-model="dietPlanDialog" title="一周食谱" fullscreen @on-cancel="closeDialog">
        <div style="width: 100%;height: 100%">
            <Col style="overflow-y: auto;flex: 1;" :style="{height: wHeight - 130 + 'px'}">
                <Collapse v-model="panelValue">
                    <Panel>
                        可食用食材
                        <p slot="content">
                            <Row type="flex">
                                <Button type="info" shape="circle" @click="infoItem_modal(item.foodMaterialId)" v-for="(item, i) in edibalFoodList" :key="i" style="margin: 2px 5px;">{{item.foodMaterialName}}</Button>
                            </Row>
                        </p>
                    </Panel>
                    <Panel >
                        不建议食用食材
                        <p slot="content">
                            <Row type="flex">
                                <Button type="info" shape="circle" @click="infoItem_modal(item.foodMaterialId)" v-for="(item, i) in inedibleFood" :key="i" style="margin: 2px 5px;">{{item.foodMaterialName}}</Button>
                            </Row>
                        </p>
                    </Panel>
                </Collapse>
                <Card>
                    <p slot="title">查询食材</p>
                    <Row style="margin: 10px 0;"  type="flex" align="middle">
                        <Col span="6">
                        <Select v-model="foodMaterial" remote filterable :remote-method="getFoodsByPinyin"  ref="setSelect"
                                clearable placeholder="请选择" @on-change="verifyFoodEatable()" @on-clear="getFoodsByPinyin()"
                                :loading="foodLoading">
                            <Option v-for="item in foodMaterialAllList" :value="item.id" :key="item.id" :label="item.name">{{item.name}}</Option>
                        </Select>
                        <!--<Select v-model="foodMaterial"  ref="setSelect"  filterable clearable placeholder="请选择" @on-change="verifyFoodEatable()">-->
                            <!--<Option v-for="item in foodMaterialAllList" :value="item.id" :key="item.id" >{{ item.name}}</Option>-->
                        <!--</Select>-->
                        </Col>
                        <Col span="6">
                        <span v-if="foodDetail != null" style="margin: 0 10px;color: #ff3d1f">{{foodDetail ? '可食用' : '禁食'}}</span>
                        </Col>
                        <Col span="10" style="display: flex;flex-direction: row;justify-content: flex-end">
                        <Button type="info" icon="ios-search" @click="verifyFoodEatable()" style="margin: 0 10px">查询</Button>
                        <Button type="info" icon="ios-search" @click="infoItem_modal(foodMaterial)">查询营养物质</Button>
                        </Col>
                    </Row>
                </Card>
                <div style="padding-bottom: 20px;">
                <Card>
                    <p slot="title">食谱</p>

                    <p>

                        <Col span="24" style="display: flex;flex-direction: row;justify-content: flex-end">
                        <Button type="info" icon="ios-search" @click="dietPlannfoModel = true" style="margin: 10px 10px">选择模板</Button>
                        </Col>
                    <Table
                            border
                            stripe
                            max-height="670"
                            :columns="columnsAdd"
                            :data="dietPlanitemTable"
                    >
                        <template v-for="week in ['sev','one','tow','thr','fou','fiv','six']" slot-scope="{ row, index }"
                                  :slot="week">
                            <Form style="margin: 10px 0" v-if="addItemInfo.dietPlan != null && row != null && index < 4">
                                <Row v-for="(foodMaterial,indes) in addItemInfo.dietPlan[row[week]]" :key="indes">
                                    <Col span="12">
                                    <!--<FormItem style="margin: 10px 5px">-->
                                        <!--<Select v-model="foodMaterial.foodMaterialId" remote transfer filterable :remote-method="dietPlanGetFoodsByPinyin"-->
                                                <!--clearable placeholder="请选择食材" @on-clear="dietPlanGetFoodsByPinyin()"-->
                                                <!--:loading="foodLoading">-->
                                            <!--<Option v-for="item in dietPlanFoodList" :value="item.id" :key="item.id" :label="item.name">{{ item.name}}</Option>-->
                                        <!--</Select>-->
                                    <!--</FormItem>-->
                                    <FormItem style="margin: 10px 5px">
                                      <Select v-if="foodMaterial.select.edit"
                                              @mouseout.native="!foodMaterial.select.click ? foodMaterial.select.edit = false : null"
                                              @click.native="foodMaterial.select.click = true"
                                              @on-change="changeSelect($event, foodMaterial)" label-in-value
                                              transfer filterable  v-model="foodMaterial.foodMaterialId" placeholder="请选择食材">
                                        <Option v-for="item in dietPlanFoodList" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                                      </Select>
                                      <div v-else @mouseover="foodMaterial.select.edit = true"
                                           style="line-height: 30px;border: 1px solid rgb(220, 222, 226);border-radius: 4px;background-color: white"
                                      >
                                        {{foodMaterial.foodMaterial != null ? foodMaterial.foodMaterial.name : foodMaterial.foodMaterialName}}
                                      </div>
                                    </FormItem>
                                    </Col>
                                    <Col span="6">
                                    <FormItem style="margin: 10px 5px">
                                        <!--<InputNumber :min="0" v-model="foodMaterial.value"-->
                                        <!--:formatter="value => `${value}克`"-->
                                        <!--placeholder="请输入食材数量"></InputNumber>-->
                                        <InputNumber :min="0" v-model="foodMaterial.value"
                                                     placeholder="请输入食材数量"></InputNumber>克
                                    </FormItem>
                                    </Col>
                                    <Col span="2">
                                    <Tooltip transfer placement="top" content="备注" theme="light">
                                        <Poptip transfer placement="right">
                                            <Button class="my_Button"
                                                    style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">
                                                <Icon type="md-git-network" size="20"/>
                                            </Button>
                                            <div class="api" slot="content">
                                                <Input type="text" v-model="foodMaterial.remark" placeholder="请输入备注"/>
                                            </div>
                                        </Poptip>
                                    </Tooltip>
                                    </Col>
                                    <Col span="4">
                                    <FormItem style="margin: 10px 5px">
                                        <Button @click="removeTemplateInfo(row[week], indes)">删除</Button>
                                    </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <FormItem style="margin: 10px 5px">
                                        <Button type="dashed" long @click="addTemplateInfo(row[week])" icon="md-add">添加新的食物</Button>
                                    </FormItem>
                                </Row>
                            </Form>
                            <div v-else>
                                <Button type="primary" @click="getFoodsNutritions(addItemInfo.dietPlan, row[week][0], 'basic')">基础物质</Button>
                                <Button type="primary" @click="getFoodsNutritions(addItemInfo.dietPlan, row[week][0])" style="margin-left: 5px">其它物质</Button>
                            </div>
                        </template>
                    </Table>
                    </p>
                </Card>
            </div>
            </Col>
        </div>
        <!--食材详情-->
        <Modal v-model="infoModel" title="食材详情" width="600">
            <Form :label-width="100">
                <Row v-if="foodInfoItem != null">
                    <Col span="12">
                    <FormItem label="食材名称：">
                        {{foodInfoItem.name}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材单位：">
                        {{foodInfoItem.unit}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材类别：">
                        {{foodInfoItem.foodMaterialType.name}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="升糖指数(GI)：">
                        {{foodInfoItem.gi}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="血糖负荷(GL)：">
                        {{foodInfoItem.gl}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材品牌：">
                        {{foodInfoItem.brand}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材产地：">
                        {{foodInfoItem.origin}}
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="食材品种：">
                        {{foodInfoItem.variety}}
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <Form label-position="top">
                <FormItem label="营养物质：" v-if="foodInfoItem != null">
                    <Table stripe max-height="250" :columns="columnsInfo" :data="foodInfoItem.nutritionTypeList"></Table>
                </FormItem>
            </Form>
        </Modal>
        <!--食谱详情-->
        <Modal v-model="dietPlannfoModel" title="食谱详情" width="1050">
            <div v-for="(item, i) in dietPlanAllList" :key="i" style="margin-bottom: 15px">
                <Col span="24" style="display: flex;flex-direction: row;justify-content: space-between; align-items: center">
                    <span style="font-weight: bold">食谱{{i + 1}}</span>
                    <Button type="info" style="margin: 10px 10px" @click="dietPlanSelect(i)">选择此模板</Button>
                </Col>
                <Table border stripe :columns="dietPlanColumns[i]" :data="itemAdd"></Table>
            </div>
        </Modal>
        <Modal v-model="nutritionModal" title="营养物质含量">
            <Table border stripe :loading="tableLoading" :columns="nutritionColumn" :data="nutritionItems"></Table>
        </Modal>
        <div slot="footer">
            <Button type="primary" size="large" @click.stop="addDietPlan">确定</Button>
        </div>
    </Modal>
</template>
<script>
    export default {
        name: "",
        props: {
            caseData: {
                type: Object,
                default: null
            },
            user: {
                type: Object,
                default: null
            },
            dietPlanDialog: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                nutritionModal: false,
                nutritionColumn:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span',params.row.name+"("
                                    + params.row.forShort+")")
                            }
                        }
                    },
                    {
                        title: '含量',
                        align: 'center',
                        render: (h, params) => {
                            if (params.row.foodNutritionId != null) {
                                return h('span', params.row.value + " " + params.row.unit)
                            }
                        }
                    },
                ], // 营养物质列
                nutritionItems:[], // 营养物质的数据
                wHeight: window.innerHeight,
                dialog: this.dietPlanDialog,
                foodLoading: false,
                panelValue: [],
                infoModel: false, // 食材弹窗
                foodInfoItem: null, // 食材详情
                foodMaterial: '', // 食材名称
                foodPinyin: '', // 食材检索的拼音
                edibalFoodList: [], // 可食用食材列表
                inedibleFood: [], // 不可食用食材列表
                foodMaterialAllList: [], // 所有食材
                tempAllFoodList: [], // 用于存所有食材的列表
                columnsInfo: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center',
                    },
                    {
                        title: '营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.foodInfoItem.nutritionTypeList[params.index]
                            return h("span", item.name + '（' + item.forShort + '） - ' + item.englishName)
                        },
                    },
                    {
                        title: '含量',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.foodInfoItem.nutritionTypeList[params.index]
                            return h("span", item.value + ' ' + item.unit)
                        },
                    },
                    {
                        title: '重点营养物质',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let item = this.foodInfoItem.nutritionTypeList[params.index]
                            return h("span", item.isKey ? '是' : '')
                        },
                    },
                ],
                dietPlanFoodList: [], // 用于添加食谱的食材选择列表
                foodDetail: null,
                key: 100,
                columnsAdd: [
                    {
                        title: '时间',
                        width: 100,
                        key: 'dataTime',
                        align: 'center',
                        fixed: 'left',
                        ellipsis: true,
                        tooltip: true,
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'sev',
                        width: 450,
                    },
                    {
                        title: '周一',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'one',
                        width: 450,
                    },
                    {
                        title: '周二',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'tow',
                        width: 450,
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'thr',
                        width: 450,
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'fou',
                        width: 450,
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'fiv',
                        width: 450,
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        slot: 'six',
                        width: 450,
                    },
                ],//食谱表头
                dietPlanitemTable: [{
                    dataTime: '早餐', one: '01', tow: '11', thr: '21', fou: '31', fiv: '41', six: '51', sev: '61'},
                    {dataTime: '午餐', one: '02', tow: '12', thr: '22', fou: '32', fiv: '42', six: '52', sev: '62'},
                    {dataTime: '晚餐', one: '03', tow: '13', thr: '23', fou: '33', fiv: '43', six: '53', sev: '63'},
                    {dataTime: '加餐', one: '04', tow: '14', thr: '24', fou: '34', fiv: '44', six: '54', sev: '64'},
                    {dataTime:'营养物质',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}], // 食谱表结构
                addItemInfo: {
                    dietPlan: {},
                },
                dietPlanAllList: [], // 推荐的食谱模板
                dietPlannfoModel: false, // 食谱模板
                dietPlanColumns: [], // 食谱模板列表
                columnsIndo:[
                    {
                        title: '时间',
                        width: 60,
                        align: 'center',
                        render:(h,params)=>{
                            let week=['早','午','晚','加']
                            return h("span",week[params.index] + "餐")
                        }
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 6 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周一',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 0 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周二',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 1 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 2 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 3 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 4 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 5 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                ],
                infoItem:{infoVOList:[]},
                dietLines: [], // 饮食原则列表
                itemAdd:[{dataTime:'早餐',one:'01',tow:'11',thr:'21',fou:'31',fiv:'41',six:'51',sev:'61'},
                    {dataTime:'午餐',one:'02',tow:'12',thr:'22',fou:'32',fiv:'42',six:'52',sev:'62'},
                    {dataTime:'晚餐',one:'03',tow:'13',thr:'23',fou:'33',fiv:'43',six:'53',sev:'63'},
                    {dataTime:'加餐',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}],
                basicNutritionItems: ['能量', '碳水化合物', '蛋白质', '脂肪'],
                tableLoading:false,
            }
        },
        created() {
            console.log('dialog', this.dialog)
            this.findUserAllFoodMaterial ()
//            this.getUserEdibalFoods()
//            this.getUserInedibleFoods ()
//            this.findAllDietPlan ()
        },
        methods: {
            // 显示当天的营养物质含量
            getFoodsNutritions (data, code, type) {
                console.log('data', data)
                console.log('code', code)
                let foods= []
                let foodId = []
                Object.keys(data).forEach(function (plan) {
                    if (plan[0] == code) {
                        data[plan].forEach(info => {let temp = {
                            id: info.foodMaterialId,
                            quantity: info.value
                        }
                            let index = foodId.indexOf(info.foodMaterialId)
                            if (index > -1) {
                                foods[index].quantity = foods[index].quantity + info.value
                            } else if (info.foodMaterialId !== ''){
                                foods.push(temp)
                                foodId.push(info.foodMaterialId)
                            }
                        })
                    }
                })
                console.log(foods)
                // 调接口查询食材的营养物质含量，只显示热量/碳水化合物/蛋白质/脂肪
                this.basicNutritions (foods, type)
            },
            // 显示当天的基础营养物质含量
            basicNutritions (foods, type) {
                if (foods == null || foods.length <= 0) {
                    this.$Notice.error({title:'未选择食材，请先选择'});
                    return
                }
                let data = []
                this.$http.post('nutrition/calculate/nutrition',foods, {emulateJSON: false}).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        data = msg.data
                        console.log('data', data)
                        this.nutritionItems = []
                        data.forEach(item => {
                            if (type === 'basic') {
                                if (this.basicNutritionItems.indexOf(item.name) > -1) {
                                    this.nutritionItems.push(item)
                                }
                            } else {
                                if (this.basicNutritionItems.indexOf(item.name) < 0) {
                                    this.nutritionItems.push(item)
                                }
                            }

                        })
                        console.log('nutritionItems', this.nutritionItems)
                        this.nutritionModal = true
                    }else {
                        this.$Notice.error({title:'营养物质获取失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            // 获取所有食材
             findUserAllFoodMaterial() {
               this.$http.post('foodMaterial/list', {
                   isDeleted: false
               }).then(function (res) {
                 let msg = res.body
                 if (msg.success) {
                   this.foodMaterialAllList = msg.data.list
                     this.dietPlanFoodList = msg.data.list
                     this.tempAllFoodList = msg.data.list
                 } else {
                   this.$Notice.error({title: '食材查询失败', desc: msg.message});
                 }
               }, function (res) {
                 this.myError(res.body)
               })
             },
            //获取患者的可食用食材列表
            getUserEdibalFoods () {
                this.$http.post('drools/getAllEdibleFood',
                    {
                        user_id:  this.user.id,
                        name: this.foodMaterial
                    }
                ).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data != null) {
                            this.edibalFoodList = msg.data
//                        this.foodMaterialAllList = msg.data
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            //获取患者的可食用食材列表
            getFoodsByPinyin (value) {
//                this.foodMaterialAllList =
                 // 判断是否有字母
                let p = /[a-z]/i;
                let b = p.test(value)
                // 如果没有字母，则调中文查询食材接口
//                if (!b) {
//                    this.foodMaterialAllList = JSON.parse(JSON.stringify(this.tempAllFoodList))
//                    return
//                }
//                 if (value == null || value === '') {
//                     this.foodMaterialAllList = JSON.parse(JSON.stringify(this.tempAllFoodList))
//                     return
//                 }
                if (!b || value == null || value === '') {
                    this.foodMaterialAllList = JSON.parse(JSON.stringify(this.tempAllFoodList))
                    return
                }
                this.foodPinyin = value
                this.$http.post('drools/getFoodListByPinyin',
                    {
                        foodpinyin:  value
                    }
                ).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data != null) {
                            this.foodMaterialAllList = JSON.parse(msg.data)
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            dietPlanGetFoodsByPinyin (value) {
                // 判断是否有字母
                let p = /[a-z]/i;
                let b = p.test(value)
                if (!b || value == null || value === '') {
                    this.dietPlanFoodList = JSON.parse(JSON.stringify(this.tempAllFoodList))
                    return
                }
                this.foodPinyin = value
                this.$http.post('drools/getFoodListByPinyin',
                    {
                        foodpinyin:  value
                    }
                ).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data != null) {
                            this.dietPlanFoodList = JSON.parse(msg.data)
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },

            // 获取患者的不可食用食材列表
            getUserInedibleFoods () {
                this.$http.post('drools/getAllInedibleFood',
                    {
                        user_id:  this.user.id,
                        name: this.foodMaterial
                    }
                ).then(function (res) {
                    let msg = res.body
                    console.log('msg_____', msg)
                    if (msg.success) {
                        if (msg.data != null) {
                            this.inedibleFood = msg.data
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            // 根据饮食原则获取可食用食材列表和不可食用食材列表
            getFoodsByDietGuidline (value) {
                // 先获取已选择原则的id
                console.log('dietGuideLines', value)
//                if (value == null || value.length <= 0) {
//                    return
//                }
                this.dietLines = value
                this.$http.post('drools/getFoodListByGuidelines',
                    {
                        ids: JSON.stringify(value)
                    }
                ).then(function (res) {
                    let msg = res.body
                    console.log('msg_____', msg)
                    if (msg.success) {
                        if (msg.data != null) {
                            this.edibalFoodList = msg.data.edibalFoodList
                            this.inedibleFood = msg.data.inedibleFoodList
                        }
                    } else {
                        this.$Notice.error({title: '查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            // 根据食材Id获取食材详情
            getFoodMaterialDetails (foodId) {
                this.$http.post('foodMaterial/detail2',
                    {
                        foodMaterialId: foodId
                    }
                ).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.foodInfoItem = msg.data
                    } else {
                        this.$Notice.error({title: '获取详情失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            // 获取食材该患者是否可食用
            verifyFoodEatable (foodId) {
                 if (this.foodMaterial == null || this.foodMaterial === '' || this.foodMaterial == undefined || this.foodMaterial === 'undefined') {
                     return
                 }
                this.$http.post('drools/checkIfFoodEdible',
                    {
                        foodId: this.foodMaterial,
                        ids: JSON.stringify(this.dietLines)
                    }
                ).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.foodDetail = msg.data
                    } else {
                        this.$Notice.error({title: '获取详情失败', desc: msg.message});
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            // 获取食材食谱
            findAllDietPlan() {
                this.$http.post('dietPlan/listTemplate', {
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                    dietGuideLinesIds: JSON.stringify(this.dietLines)
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.dietPlanAllList = msg.data.list
                        this.convertDietPlan()
                    } else {
                        if (msg.code === '201' || msg.message==='未登录') {
                            this.$Notice.error({title: '登录过期，请重新登录'});
                            this.$router.push('/')
                        } else {
                            this.$Notice.error({title: '饮食计划模板查询失败', desc: msg.message});
                        }
                    }
                }, function (res) {
                    this.myError(res.body)
                })
            },
            // 转换食谱模板以供显示
            convertDietPlan () {
                this.dietPlanColumns = []
                 for (let i in this.dietPlanAllList) {
                     this.dietPlanColumns.push(
                         [
                             {
                                 title: '时间',
                                 width: 60,
                                 align: 'center',
                                 render:(h,params)=>{
                                     let week=['早','午','晚','加']
                                     return h("span",week[params.index] + "餐")
                                 }
                             },
                             {
                                 title: '周天',
                                 key: 'age',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 6 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周一',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 0 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周二',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 1 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周三',
                                 key: 'age',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 2 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周四',
                                 key: 'age',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 3 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周五',
                                 key: 'age',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 4 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                             {
                                 title: '周六',
                                 key: 'age',
                                 align: 'center',
                                 render:(h,params)=>{
                                     let code = 5 + "" + (params.index+1)
                                     let hList = []
                                     this.dietPlanAllList[i].infoVOList.forEach(function (infoVO) {
                                         if (infoVO.type == code) {
                                             infoVO.infoList.forEach(function (info) {
                                                 if (info.remark.length <= 0) {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                                 } else {
                                                     hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                                 }
                                             })
                                             return
                                         }
                                     })
                                     return h("div",hList)
                                 }
                             },
                         ]
                     )
                 }
            },
            // 选择某个食谱模板以供编辑
            dietPlanSelect(value) {
                if (value == undefined) {
                    return
                }
                let infoList = {}
                let dietPlan = this.dietPlanAllList[value]
                // dietPlan.infoVOList.map((item)=>{
                //     infoList[item.type] = item.infoList
                // })
                dietPlan.infoVOList.forEach((i)=>{
                  i.infoList.forEach((info)=> {
                    info['key'] = this.key++
                    info['unit'] = info.foodMaterial.unit
                    info['select'] = {edit: false, click: false}
                    if (!infoList[info.type])  infoList[info.type] = []
                    infoList[info.type].push(JSON.parse(JSON.stringify(info)))
                  })
                })
                this.addItemInfo.dietPlan = infoList
                this.dietPlannfoModel = false
            },
            changeSelect(value,templateInfo){
              if (templateInfo.foodMaterial != null && templateInfo.foodMaterial.name != null) {
                templateInfo.foodMaterial.name = value.label
              }
              templateInfo['foodMaterialName'] = value.label
              templateInfo.select.edit = templateInfo.select.click = false
            },
            // 食谱添加食材
            addTemplateInfo(week) {
                this.dietPlanFoodList = JSON.parse(JSON.stringify(this.tempAllFoodList))
                if (this.addItemInfo.dietPlan[week] == null) {
                    let diet = []
                    diet.push({
                      foodMaterialId: '',
                      type: week,
                      value: 0,
                      unit: '',
                      remark: '',
                      select: {edit: true, click: true},
                      key: this.key++
                    })
                    this.$set(this.addItemInfo.dietPlan, week, diet)
                } else {
                    this.addItemInfo.dietPlan[week].push({
                        foodMaterialId: '',
                        type: week,
                        value: 0,
                        unit: '',
                        remark: '',
                        select: {edit: true, click: true},
                        key: this.key++
                    })
                }
                this.$forceUpdate()
                console.log('dietPlan', this.addItemInfo.dietPlan)
            },
            // 食谱删除食材
            removeTemplateInfo(key, index) {
                this.addItemInfo.dietPlan[key].splice(index, 1)
            },
            // 食谱确定
            addDietPlan () {
                //食谱
                if (this.addItemInfo.dietPlan == null || this.addItemInfo.dietPlan == {} || this.addItemInfo.dietPlan['dep'] != null) {
                    this.$Notice.warning({title: '请先制定食谱'})
                    return
                }
                let flag = false
                let that = this
                Object.keys(this.addItemInfo.dietPlan).forEach(function (key) {
                    that.addItemInfo.dietPlan[key].forEach(function (TemplateInfo) {
                        if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0) {
                            flag = true
                            return
                        }
                    })
                })
                if (flag || this.addItemInfo.dietPlan.length <= 0) {
                    return this.$Message.warning('食谱存在空行，请完善或删除');
                }
                this.$emit('closeDialog', this.addItemInfo)
            },
            closeDialog () {
                this.$emit('closeDialog')
            },
            infoItem_modal(item) {
                this.getFoodMaterialDetails(item)
                this.infoModel = true
            }
        }
    }
</script>

<style scoped>

</style>
